// extracted by mini-css-extract-plugin
module.exports = {"customCursorCotainer":"ZoomableImage_customCursorCotainer__G_bMU","imageItemButton":"ZoomableImage_imageItemButton__hXJR2"};